// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"626047be","635":"50851d65","787":"d3befce1"}[chunkId] + ".chunk.js";
};